enum PaymentsApiVersion {
  ScheduledRefund = 'scheduled-refund',
  V1 = 'V1',
  V2 = 'V2',
  V3 = 'V3',
}

export { PaymentsApiVersion };
